import { Event } from 'api/Serializers/Appointments';
import { UserType } from 'config';

export const SECTION_CLASSES = 'w-full p-6 space-y-6 bg-white';

export interface SectionProps {
  appointment: Event;
  userType: UserType;
}
